
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class PaymentMethod extends Vue {
  @Prop({ type: Array })
  paymentMethodsToShow!: Array<string>;
  @Prop({ type: String })
  selectedPaymentType!: string;
  @Prop({ type: Boolean })
  isPaymentFormLoaded!: boolean;
  @Prop({ type: Boolean })
  paymentMethodsLoading!: boolean;
  isDirectDebitEnabled: boolean = process.env.VUE_APP_FEATURE_SEPA === 'true';
  currentPaymentMethod: string = this.selectedPaymentType;
}
